// extracted by mini-css-extract-plugin
export default {"history":"History_history__5XMYg","url":"History_url__X-Icn","long":"History_long__q6-my","short":"History_short__4mmYK"};